module.exports = __webpack_public_path__ + "img/elegant.c84760e.webp";